import Button from 'components/Button';
import Header from 'components/Header';
import Navbar from 'components/Nav/Navbar';
import UserList from 'components/UserManagement/UserList';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useStores from 'stores/helpers/useStores';
import { ROUTE } from 'utils/routes';

const UserManagement: React.FC = () => {
  const navigate = useNavigate();
  const { authStore } = useStores();

  useEffect(() => {
    if (!authStore.profile?.admin) {
      navigate(ROUTE.HOME);
    }
  }, [authStore.profile?.admin]);

  return (
    <>
      <Navbar />
      <Header
        back
        title="User management"
        description="Create and delete users"
        action={
          <Button
            size="small"
            width="xs"
            color="secondary"
            onClick={() => navigate(ROUTE.NEW_USER)}
          >
            Create user
          </Button>
        }
      />
      <UserList />
    </>
  );
};

export default UserManagement;
